import { priorityLabel } from './presentation';
import { formatDateTime } from './formatDate';
/** Return the shared display label for a task status. */
export const statusLabel = (status: string): string => ({
  not_started: 'Not started', acknowledged: 'Acknowledged', started: 'In progress',
  blocked: 'Blocked', complete: 'Complete', cancelled: 'Cancelled',
}[status] || status);

/** Translate status tokens in an audit entry without changing its wording. */
export const formatTaskHistory = (text?: string): string =>
  (text || '').replace(/\bcritical\b/gi, () => priorityLabel('critical')).replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi, 'User').replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?/g, value => formatDateTime(value)).replace(/\b(not_started|acknowledged|started|blocked|complete|cancelled)\b/g, statusLabel);

/** Show a person's role and organisation in assignment pickers. */
export const assigneeLabel = (user: { name: string; role: string; client_name?: string }): string =>
  `${user.name} (${({ facility_manager: 'Facility manager', client: 'Client', consultant: 'Consultant', h2okay_admin: 'Administrator' } as Record<string, string>)[user.role] || user.role}${user.client_name ? ` · ${user.client_name}` : ''})`;

/** Match open dated tasks against the selected local calendar interval. */
export const matchesDueFilter = (task: { status: string; due_by?: string | null }, filter: string): boolean => {
  if (filter === 'all') return true;
  if (!task.due_by || ['complete', 'cancelled'].includes(task.status)) return false;
  const due = new Date(task.due_by);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const week = new Date(today);
  week.setDate(week.getDate() + 7);
  if (filter === 'today') return due >= today && due < tomorrow;
  if (filter === 'week') return due >= today && due < week;
  if (filter === 'overdue') return due < today;
  return true;
};

/** Treat a selected calendar date as the end of the local day. */
export function endOfDueDay(value: string): string {
  return new Date(`${value}T23:59:59.999`).toISOString();
}

/** Compare calendar days so a task due today stays actionable all day. */
export function isTaskOverdue(task: {due_by?: string | null; status: string}): boolean {
  return matchesDueFilter(task, 'overdue');
}
